// Component
// ------------------------------------------------------------
import './components/_page.navigation';
import './components/_page.modal';
import './misc/_eu-cookie-compliance';
import './misc/_consent';
import './misc/_scroll-menu';

// Block
// ------------------------------------------------------------
import './block/_block.banner';
import './block/_block.gallery';
import './block/_block.flat-picker';
import './block/_block.residence-cards';

(function ($, Drupal) {
  Drupal.behaviors.documentReadyBehaviors = {
    attach: function (context) {
      once('documentReadyBehaviors', 'html', context).forEach(function () {
        // Lightbox Setup
        lightbox.option({
          resizeDuration: 200,
          disableScrolling: true,
          maxWidth: '80vw',
          maxHeight: '80vh',
        });

        // Wow Setup
        new WOW().init();
      });
    },
  };
}(jQuery, Drupal));
